import API from "@/models/API";

export default class ExternalLinks {
    constructor(item = {}) {
        this.url = item.url || null;
    }

    static getExternalLinks = (query) =>
        API.get(
            `/stores/${localStorage.getItem("storeId")}/store-external-links${query}`
        );

    static addExternalLink = (payload) =>
        API.post(
            `/stores/${localStorage.getItem("storeId")}/store-external-links`,
            payload
        );

    static uploadImage = (id, image) =>
        API.post(
            `/stores/${localStorage.getItem("storeId")}/store-external-links/${id}`,
            image
        );

    static delete = (id) =>
        API.delete(
            `/stores/${localStorage.getItem("storeId")}/store-external-links/${id}`,
        );
}
